import { render, staticRenderFns } from "./DialogBankStatement.vue?vue&type=template&id=456a16ca"
import script from "./DialogBankStatement.vue?vue&type=script&lang=js"
export * from "./DialogBankStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports